import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCentrifugalCompressor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 70,
	height: 67,
	viewBox: "0 0 70.0 67.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 12.0 54.0 L 0.0 67.0 L 60.0 67.0 L 48.0 54.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.6 25.0 A 30.0 30.0 0.0 0 1 30.0 0.0 L 70.0 0.0 L 70.0 20.0 L 58.45 20.0 A 30.0 30.0 0.0 1 1 0.6 35.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgCentrifugalCompressor;
